import React from 'react'
import { motion } from "framer-motion";
import Typical from "react-typical";

const Banner = () => {
  const goToProjects = () => {
    const element = document.getElementById("project");
    element?.scrollIntoView({
      behavior: "smooth",
    });
  };

  return (
    <section id="home" className='max-w-contentContainer mx-auto py-10 mdl:py-24 flex flex-col gap-4 lgl:gap-8 mdl:px-10 xl:px-4'>
        <motion.h3 
        initial={{y: 10, opacity: 0}}
        animate={{y: 0, opacity: 1}}
        transition={{duration: 0.5, delay: 0.5}}
        className='text-lg font-titleFont tracking-wide text-textGreen'>Hi, my name is</motion.h3>
        <motion.h1 
        initial={{y: 10, opacity: 0}}
        animate={{y: 0, opacity: 1}}
        transition={{duration: 0.5, delay: 0.7}}
        className="text-4xl lgl:text-6xl font-titleFont font-semibold flex flex-col">Bunmi Oladipupo. <span className='text-textDark mt-2 lgl:mt-4'>I am a <Typical
          steps={[
            "Software Engineer...",
            3000,
            "Developer...",
            3000,
            "Frontend Engineer...",
            3000,
            "Backend Engineer...",
            3000,
            "Lover of Tech.",
            1000
          ]}
          loop={Infinity}
          wrapper="span"
        />
        </span></motion.h1>
        <motion.p 
        initial={{y: 10, opacity: 0}}
        animate={{y: 0, opacity: 1}}
        transition={{duration: 0.5, delay: 0.8}}
        className='text-base md:max-w-[650px] text-textDark font-medium'>
            With 3 years of experience in React, Node and PHP, I pride myself as an innovative and self-challenging software engineer. My skills cut across Frontend technologies, Backend technologies and Cloud computing. 
            {" "}
        </motion.p>
        <motion.button 
        initial={{y: 10, opacity: 0}}
        animate={{y: 0, opacity: 1}}
        transition={{duration: 0.5, delay: 0.9}}className='w-52 h-14 text-sm font-titleFont border border-textGreen rounded-md text-textGreen tracking-wide hover:bg-hoverColor duration-300' onClick={goToProjects}>
            Checkout my projects
        </motion.button>
    </section>
  )
}

export default Banner